import { render, staticRenderFns } from "./MyPageUpdate.vue?vue&type=template&id=62ba1aec&scoped=true"
import script from "./MyPageUpdate.vue?vue&type=script&lang=js"
export * from "./MyPageUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ba1aec",
  null
  
)

export default component.exports